import gql from "graphql-tag";

export const LIST_EVENTS_BY_SITE_ID = gql`
  query LIST_EVENTS_BY_SITE_ID($id: String) {
    nodeQuery(
      filter: {
        conditions: {
          field: "field_event_heritage_site.entity.nid"
          value: [$id]
          operator: IN
        }
      }
    ) {
      entities {
        ... on NodeEvent {
          uuid
          entityId
          title
          fieldContent {
            entity {
              ... on ParagraphCopy {
                fieldCopy {
                  value
                }
              }
              ... on ParagraphAudio {
                fieldAudioUrl
              }
              ... on ParagraphImage {
                fieldImage {
                  alt
                  url
                }
              }
              ... on ParagraphVideo {
                fieldVideoUrl
              }
            }
          }
          fieldEndDate {
            value
            date
          }
          fieldStartDate {
            value
            date
          }
          fieldHero {
            entity {
              ... on ParagraphHeroImage {
                fieldHeroImage {
                  alt
                  url
                }
              }
              ... on ParagraphHeroVideo {
                fieldHeroVideoUrl
              }
            }
          }
          fieldSiteLink {
            uri
            title
          }
        }
      }
    }
  }
`;
